<canvas #canvas [attr.height]="height"></canvas>

@if (chart) {
    <ion-list>
        @for (data of legendItems; track data.text) {
            <ion-item>
                <ion-icon name="fas-square" slot="start" [style.color]="data.fillStyle" aria-hidden="true" />
                <ion-label>{{data.text}}</ion-label>
            </ion-item>
        }
    </ion-list>
}
